import { Component, input } from '@angular/core';

import { SharedComponentsModule } from '@well/shared-components';
import { Maybe } from '@irian-ro/util-functions';
import { DateTimeWithTimezoneModel } from '@irian-ro/date-utils';

@Component({
    selector: 'well-task-card-checkpoint',
    imports: [SharedComponentsModule],
    templateUrl: './task-card-checkpoint.component.html',
    styleUrl: './task-card-checkpoint.component.scss'
})
export class TaskCardCheckpointComponent {

  location = input.required<Maybe<string>>();
  namedLocationCode = input<Maybe<string>>();
  namedLocationLabel = input<Maybe<string>>();
  timeWindowStart = input.required<Maybe<DateTimeWithTimezoneModel>>();
  timeWindowEnd = input.required<Maybe<DateTimeWithTimezoneModel>>();

}
